<template>
  <header id="site-header">
    <figure class="logo">
      <a href="/">
        <img src="/images/common/logo.webp" alt="株式会社ゼンケイ" />
      </a>
    </figure>
    <div class="trg" @click="trg = !trg">
      <svg v-if="!trg" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M160-680v-40h640v40H160Zm0 440v-40h640v40H160Zm0-220v-40h640v40H160Z"/></svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M256-227.69 227.69-256l224-224-224-224L256-732.31l224 224 224-224L732.31-704l-224 224 224 224L704-227.69l-224-224-224 224Z"/></svg>
    </div>
    <transition name="fade">
      <nav v-show="trg" class="gnavi" role="navigation" itemscope itemtype="http://scheme.org/SiteNavigationElement">
        <ul>
          <li itemprop="name">
            <a :class="{ active: isActive('/about/') }" href="/about/" itemprop="url">ゼンケイについて<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="m531.69-480-184-184L376-692.31 588.31-480 376-267.69 347.69-296l184-184Z"/></svg></a>
          </li>
          <li itemprop="name">
            <a :class="{ active: isActive('/solution/') }" href="/solution/" itemprop="url">ゼンケイの関わる世界<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="m531.69-480-184-184L376-692.31 588.31-480 376-267.69 347.69-296l184-184Z"/></svg></a>
          </li>
          <li itemprop="name">
            <a :class="{ active: isActive('/company/') }" href="/company/" itemprop="url">会社概要<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="m531.69-480-184-184L376-692.31 588.31-480 376-267.69 347.69-296l184-184Z"/></svg></a>
          </li>
          <li itemprop="name" class="spv">
            <a :class="{ active: isActive('/contact/') }" href="/company/" itemprop="url">お問い合わせ<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="m531.69-480-184-184L376-692.31 588.31-480 376-267.69 347.69-296l184-184Z"/></svg></a>
          </li>
        </ul>
      </nav>
    </transition>
    <a href="/contact/" class="btn">お問い合わせ</a>
    <transition name="fade">
      <div v-if="trg" id="overlay"></div>
    </transition>
  </header>
</template>

<style lang="scss" scoped>
header{
  width: 100%;
  position: absolute;
  padding: .8rem side();
  display: grid;
  grid-template-columns: auto auto;
  z-index: 1000;
  &.active{
    @media screen and (min-width: calc($tab + 1px)){
      position: fixed;
      background: $white;
      padding: .64rem side();
      transform: translateY(-100%);
      animation: viewHeader 400ms $ease forwards;
      @keyframes viewHeader {
        0%{
          transform: translateY(-100%);
        }
        100%{
          transform: translateY(0);
        }
      }
      .logo{
        width: 9rem;
        transform: translateY(.72rem) scale(1.2);
        animation: logoScale 400ms 200ms $ease forwards;
        @keyframes logoScale {
          0%{
            transform: translateY(.72rem) scale(1);
          }
          100%{
            transform: translateY(.72rem) scale(1.2);
          }
        }
      }
      nav{
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  > *{
    align-self: center;
  }
  .logo{
    width: 10rem;
    justify-self: flex-start;
    transform: translateY(.8rem) scale(1.1);
    @media screen and (max-width: $tab){
      width: 8.8rem;
      transform: translateY(.4rem);
    }
    img{
      width: 100%;
    }
  }
  .trg{
    position: absolute;
    top: .8rem;
    right: .8rem;
    width: 3.6rem;
    height: 3.6rem;
    border-radius: 50%;
    background: $base;
    @include flex();
    align-items: center;
    justify-content: center;
    cursor: pointer;
    @media screen and (min-width: calc(#{$phone} + 1px)){
      display: none !important;
    }
    svg{
      width: 2rem;
      fill: $white;
    }
  }
  nav{
    position: absolute;
    top: 50%;
    left: 18rem;
    transform: translateY(-50%);
    @media screen and (max-width: $tab){
      left: calc(50% - 1.2rem);
      transform: translate(-50%, -50%);
    }
    @media screen and (min-width: calc(#{$phone} + 1px)){
      display: block !important;
      opacity: 1 !important;
    }
    @media screen and (max-width: $phone){
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      transform: translate(0);
      background: $white;
      padding: var(--head) 0 0;
      z-index: -1;
      box-shadow: 0 0 3.2rem rgba($normal,.12);
    }
    ul{
      @include flex();
      justify-content: center;
      align-items: center;
      @media screen and (max-width: $phone){
        padding: 2rem 0 0;
        display: block;
      }
      li{
        margin: 0 0 0 2.8rem;
        font-weight: 500;
        @media screen and (max-width: $tab){
          margin: 0 0 0 2.4rem;
          font-size: .96rem;
        }
        @media screen and (max-width: $phone){
          margin: 0;
          border-bottom: $border 1px solid;
          &:last-child{
            border: none;
          }
        }
        &.spv{
          display: none;
          @media screen and (max-width: $phone){
            display: block;
          }
        }
        a{
          @media screen and (max-width: $phone){
            padding: 1.12rem side();
            display: block;
            font-size: 1.12rem;
            position: relative;
          }
          &.active,
          &:hover{
            color: $base;
          }
          svg{
            display: none;
            @media screen and (max-width: $phone){
              display: block;
              position: absolute;
              top: 50%;
              right: side();
              transform: translateY(-50%);
              width: 1.72rem;
              fill: $normal;
              opacity: .32;
            }
          }
        }
        &:first-child{
          margin: 0;
        }
      }
    }
  }
  .btn{
    justify-self: flex-end;
    @include btn($white, $base);
    @media screen and (max-width: $tab){
      padding: .88rem 2.4rem;
    }
    @media screen and (max-width: $phone){
      display: none;
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.4s $ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  #overlay{
    position: fixed;
    top: 0;
    left: 0;
    z-index: -2;
    background: rgba($normal,.8);
    width: 100%;
    height: 100%;
    @media screen and (min-width: calc(#{$phone} + 1px)){
      display: none !important;
    }
  }
}

</style>

<script>
import { ref } from 'vue'
export default {
  data: function(){
    return {
      trg: false
    }
  },
  methods: {
    isActive(path) {
      return window.location.pathname.startsWith(path)
    }
  },
}
</script>
